<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div class="flex flex-col gap-4">
    <p class="text-center text-lg">
      {{ t.line1 }}<br />
      {{ t.line2 }}<br />
      {{ t.line3 }}
    </p>

    <div class="grid grid-cols-1 gap-2">
      <button
        id="comfy_gopricing"
        class="cursor-pointer rounded-md border-nordy-main bg-nordy-main px-4 py-2 font-semibold text-white"
        @click="viewPlans"
      >
        <span class="pointer-events-none">{{ t.viewPlans }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useNordyUserStore } from '@/nordy/store/nordyUserStore'
import { useDialogStore } from '@/stores/dialogStore'

const texts = {
  ko: {
    title: '크레딧이 모두 소진되었습니다!',
    line1: '크레딧이 모두 소진되었습니다!',
    line2: '멋진 구독 플랜을 확인해 보세요.',
    line3: '풍부한 크레딧과 놀라운 기능을 누릴 수 있습니다!',
    viewPlans: '플랜 보기'
  },
  en: {
    title: 'Oops! Credits all gone!',
    line1: "Looks like you've run out of credits!",
    line2: 'How about checking out our awesome subscription plans?',
    line3: 'Get tons of credits and unlock amazing features!',
    viewPlans: 'View Plans'
  }
}

const nordyUserStore = useNordyUserStore()
const t = computed(() =>
  nordyUserStore.nordyUser?.language === 'ko' ? texts.ko : texts.en
)

const dialogStore = useDialogStore()

function viewPlans() {
  window.open('/pricing', '_blank')
  dialogStore.closeDialog({ key: 'nordy-purchase' })
}
</script>
